import React, { Fragment } from "react";
import { Badge, Pagination } from "react-bootstrap";

const getTypeBadge = (type) => {
  switch (type) {
    case "add":
    case "return":
      return "success";
    case "sell":
    case "withdraw":
    case "material_issue":
      return "danger";
    case "adjust":
      return "warning";
    default:
      return "secondary";
  }
};

const formatQuantity = (qty) => {
  if (qty > 0) return `+${qty}`;
  return `${qty}`;
};

const StockLogsItem = ({
  items,
  getPrev,
  getNext,
  isStart,
  isEnd,
  totalPages,
  currentPage,
  goToPage,
}) => {
  const getPageNumbers = () => {
    const delta = 1;
    const pages = [];
    const left = Math.max(2, currentPage - delta);
    const right = Math.min(totalPages - 1, currentPage + delta);

    pages.push(1);
    if (left > 2) pages.push("left-ellipsis");
    for (let i = left; i <= right; i++) {
      pages.push(i);
    }
    if (right < totalPages - 1) pages.push("right-ellipsis");
    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table mb-0 table-striped">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Date</th>
                      <th>Item Name</th>
                      <th>Item Type</th>
                      <th>Type</th>
                      <th>Qty</th>
                      <th>Stock Before</th>
                      <th>Stock After</th>
                      <th>Lots</th>
                      <th>Notes</th>
                      <th>Created By</th>
                    </tr>
                  </thead>
                  <tbody id="items-table">
                    {items.map((item, index) => {
                      const createdAt = item.createdAt
                        ? item.createdAt.toDate
                          ? item.createdAt.toDate()
                          : new Date(item.createdAt)
                        : null;

                      return (
                        <tr key={index} className="btn-reveal-trigger">
                          <td className="py-1">{index + 1}</td>
                          <td className="py-2">
                            {createdAt
                              ? createdAt.toLocaleDateString("th-TH", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                })
                              : "-"}
                          </td>
                          <td className="py-2">{item.itemName}</td>
                          <td className="py-2">{item.itemType}</td>
                          <td className="py-2">
                            <Badge variant={getTypeBadge(item.type)}>
                              {item.type}
                            </Badge>
                          </td>
                          <td className="py-2">{formatQuantity(item.quantity)}</td>
                          <td className="py-2">{item.stockBefore}</td>
                          <td className="py-2">{item.stockAfter}</td>
                          <td className="py-2">
                            {(item.lotAllocations || []).map((allocation) => allocation.lotNo || allocation.lotId).join(", ") || "-"}
                          </td>
                          <td className="py-2">{item.notes || "-"}</td>
                          <td className="py-2">{item.createdBy}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  className="pagination-primary pagination-circle"
                  size="lg"
                >
                  <Pagination.Prev onClick={getPrev} disabled={isStart} />
                  {pageNumbers.map((item) =>
                    typeof item === "string" ? (
                      <Pagination.Ellipsis key={item} disabled />
                    ) : (
                      <Pagination.Item
                        key={item}
                        active={item === currentPage}
                        onClick={() => goToPage(item)}
                      >
                        {item}
                      </Pagination.Item>
                    )
                  )}
                  <Pagination.Next onClick={getNext} disabled={isEnd} />
                </Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default StockLogsItem;
